import { StyledGridContainer } from '@components/Grid/Grid.style';
import { StyledDisplay, StyledHeading, StyledLabel, StyledParagraph } from '@components/Text';
import { FlippedIcon, ImgContainFit, ImgCover, ImgWH, ImgWidth100, ParagraphColor, Spacing, SpacingDTM } from '@pages/CommonStyle/common.style';
import { DivAllCenter, DivBorderRaiuds, DivFlexColumn } from '@pages/CommonStyle/commonDiv.style';
import React, { PropsWithChildren, useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import {
  FadingImage,
  RecommendButton,
  RecommendButtonBox,
  RecommendImage,
  RecommendImg,
  RecommendLayout,
  RecommendMore,
  RecommendSection,
  RecommendTextBox,
  RecommendTextLayout,
  ReommendSlider,
  Space,
} from './Recommend.style';
import { IconArrowLeft } from '@assets/images/icon';
import { useSelector } from 'react-redux';
import { CommonState } from '@redux/reducers/commonReducer';
import RecommendProducts from './RecommendProducts';

interface ModalDefaultType {
  pageName: string;
  path: any;
}

const Recommend = ({ pageName, path }: PropsWithChildren<ModalDefaultType>) => {
  const layoutType = useSelector((state: CommonState) => state.gridLayoutType);
  const labelData = layoutType !== 'mobile' ? path.recommend.labels.desktop : path.recommend.labels.mobile;
  const desktopImages = path.recommend.labels.desktop.map((item: any) => item.img);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);
  const [imgSrc, setImgSrc] = useState<string>(layoutType !== 'mobile' ? labelData[0].img : labelData[0].data.img);

  const handleChange = (nextIndex: number) => {
    setFade(false); // 먼저 페이드 아웃
    setTimeout(() => {
      const next = labelData[nextIndex];
      setImgSrc(layoutType !== 'mobile' ? next.img : next.data.img);
      setCurrentIndex(nextIndex);
      setFade(true); // 페이드 인
    }, 200); // 페이드 아웃 시간보다 짧게
  };

  const handlePrev = () => {
    const nextIndex = (currentIndex - 1 + labelData.length) % labelData.length;
    handleChange(nextIndex);
  };

  const handleNext = () => {
    const nextIndex = (currentIndex + 1) % labelData.length;
    handleChange(nextIndex);
  };

  useEffect(() => {
    if (layoutType === 'mobile') {
      const interval = setInterval(() => {
        const nextIndex = (currentIndex + 1) % desktopImages.length;
        handleChange(nextIndex);
      }, 3000);

      return () => clearInterval(interval); // cleanup
    }
  }, [layoutType, currentIndex]);

  const label = labelData[currentIndex];

  return (
    <RecommendLayout>
      <StyledGridContainer>
        <DivAllCenter>
          <StyledDisplay size={'small'}>
            <Trans i18nKey={path.recommend.title} />
          </StyledDisplay>
          <Spacing pixel="8" />
          <StyledParagraph size={'medium'}>
            <Trans i18nKey={path.recommend.desc} />
          </StyledParagraph>
          <SpacingDTM d="64" t="64" m="48" />
        </DivAllCenter>

        {path.recommend.labels.products ? (
          <>
            <RecommendProducts products={path.recommend.labels.products} />
          </>
        ) : (
          <>
            {layoutType === 'mobile' && (
              <>
                <RecommendImg src={desktopImages[currentIndex]} fade={fade} /> <Spacing pixel="16" />
              </>
            )}
            <ReommendSlider>
              {layoutType === 'mobile' ? (
                // ✅ 모바일: 여러 카드 (가로 스크롤)
                <>
                  {labelData.map((label: any, index: number) => (
                    <div key={index}>
                      <RecommendSection>
                        <RecommendImage>
                          <ImgCover src={label.data.img} />
                        </RecommendImage>

                        <RecommendTextLayout>
                          <Spacing pixel="24" />
                          <RecommendTextBox>
                            <StyledHeading size="xsmall">
                              <Trans i18nKey={label.data.title} />
                            </StyledHeading>
                            <Spacing pixel="8" />
                            <ParagraphColor size="medium" color="#818181">
                              <Trans i18nKey={label.data.desc} />
                            </ParagraphColor>
                            <Spacing pixel="24" />
                            <RecommendMore href={label.data.link}>
                              <StyledLabel size="medium">
                                <Trans i18nKey={`Learn More`} />
                              </StyledLabel>
                            </RecommendMore>
                          </RecommendTextBox>
                          <Spacing pixel="94" />
                        </RecommendTextLayout>
                      </RecommendSection>
                    </div>
                  ))}
                </>
              ) : (
                // ✅ 데스크탑: fade 전환 1장
                <div>
                  <RecommendSection>
                    <RecommendImage>
                      <FadingImage src={imgSrc} fade={fade} />
                    </RecommendImage>

                    <RecommendTextLayout>
                      <RecommendTextBox>
                        <StyledHeading size="xsmall">
                          <Trans i18nKey={labelData[currentIndex].data.title} />
                        </StyledHeading>
                        <Spacing pixel="8" />
                        <StyledParagraph size="medium">
                          <Trans i18nKey={labelData[currentIndex].data.desc} />
                        </StyledParagraph>
                        <Spacing pixel="24" />
                        <RecommendMore href={labelData[currentIndex].data.link}>
                          <StyledLabel size="medium">
                            <Trans i18nKey={`Learn More`} />
                          </StyledLabel>
                        </RecommendMore>
                      </RecommendTextBox>

                      <RecommendButtonBox>
                        <RecommendButton onClick={handlePrev}>
                          <ImgWH w="16" h="16" src={IconArrowLeft} />
                        </RecommendButton>
                        <RecommendButton onClick={handleNext}>
                          <FlippedIcon w="16" h="16" src={IconArrowLeft} />
                        </RecommendButton>
                      </RecommendButtonBox>
                    </RecommendTextLayout>
                  </RecommendSection>
                </div>
              )}
            </ReommendSlider>
          </>
        )}
      </StyledGridContainer>
    </RecommendLayout>
  );
};

export default Recommend;
